// GoogleMapView.tsx
import React from 'react'
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api'

const containerStyle = {
  width: '100%',
  height: '500px',
}

const center = {
  lat: 41.3330154,
  lng: 2.1154034,
}

const GoogleMapView = () => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyCBN7BIbUe7-rsYLtF3uNn9bYIKetHOHAY', // замените на свой API ключ
  })

  if (!isLoaded) return <div>Загрузка карты...</div>

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={17}>
      <Marker position={center} />
    </GoogleMap>
  )
}

export default GoogleMapView

// Использование в компоненте (например, внутри RouteBoard или другой страницы):
// import GoogleMapView from './GoogleMapView';
// <GoogleMapView />
